/**
 * Toast Notification System
 * 
 * API:
 * - theme.showToast(message, type, duration)
 * 
 * Types: 'success', 'error', 'info', 'warning'
 */

(function() {
  'use strict';

  /**
   * Cria container de toasts se não existir
   */
  function createToastContainer() {
    let container = document.getElementById('toast-container');
    
    if (!container) {
      container = document.createElement('div');
      container.id = 'toast-container';
      container.className = 'toast-container';
      document.body.appendChild(container);
    }
    
    return container;
  }

  /**
   * Mostra uma notificação toast
   */
  function showToast(message, type = 'success', duration = 3000) {
    const container = createToastContainer();
    
    const toast = document.createElement('div');
    toast.className = `toast toast--${type}`;
    
    // Ícone baseado no tipo
    let icon = '';
    switch(type) {
      case 'success':
        icon = '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="20 6 9 17 4 12"></polyline></svg>';
        break;
      case 'error':
        icon = '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="10"></circle><line x1="15" y1="9" x2="9" y2="15"></line><line x1="9" y1="9" x2="15" y2="15"></line></svg>';
        break;
      case 'info':
        icon = '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="16" x2="12" y2="12"></line><line x1="12" y1="8" x2="12.01" y2="8"></line></svg>';
        break;
      case 'warning':
        icon = '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"></path><line x1="12" y1="9" x2="12" y2="13"></line><line x1="12" y1="17" x2="12.01" y2="17"></line></svg>';
        break;
    }
    
    toast.innerHTML = `
      <div class="toast__icon">${icon}</div>
      <div class="toast__message">${message}</div>
      <button class="toast__close" aria-label="Fechar">
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <line x1="18" y1="6" x2="6" y2="18"></line>
          <line x1="6" y1="6" x2="18" y2="18"></line>
        </svg>
      </button>
    `;
    
    container.appendChild(toast);
    
    // Animação de entrada
    requestAnimationFrame(() => {
      toast.classList.add('toast--show');
    });
    
    // Botão de fechar
    const closeBtn = toast.querySelector('.toast__close');
    closeBtn.addEventListener('click', () => {
      hideToast(toast);
    });
    
    // Auto-hide
    if (duration > 0) {
      setTimeout(() => {
        hideToast(toast);
      }, duration);
    }
    
    return toast;
  }

  /**
   * Esconde uma notificação toast
   */
  function hideToast(toast) {
    toast.classList.remove('toast--show');
    toast.classList.add('toast--hide');
    
    setTimeout(() => {
      toast.remove();
    }, 300);
  }

  // API Pública
  window.theme = window.theme || {};
  window.theme.showToast = showToast;

})();
